'use client'

import cn from 'clsx'

import { Button, Copy, ImageBox } from 'shared-components'

import { getSanityLink } from 'shared-functions'

import SocialLinks from './SocialLinks'

import { type Cta as CtaType } from '../../../../../apps/benmax/src/types/sanity.types'

import s from './Cta.module.sass'

type ExtendedCtaType = CtaType & {
    site: string
    siteSettings: any
}

function Cta({
    useFieldsFromSettings,
    title,
    copy,
    link,
    showSocialLinks,
    image,
    reverse,
    noClipPaths,
    lightButtonColour,
    siteSettings,
    contentAlignment,
    mainBackgroundColour,
    hideMainTopBorder,
}: ExtendedCtaType) {
    const _title = useFieldsFromSettings ? siteSettings?.cta?.title || null : title || null
    const _copy = useFieldsFromSettings ? siteSettings?.cta?.copy || null : copy || null
    const _showSocialLinks = useFieldsFromSettings
        ? siteSettings?.cta?.showSocialLinks || null
        : showSocialLinks || null
    const _image = useFieldsFromSettings ? siteSettings?.cta?.image || null : image || null
    const _reverse = useFieldsFromSettings ? siteSettings?.cta?.reverse || null : reverse || null
    const _noClipPaths = useFieldsFromSettings ? siteSettings?.cta?.noClipPaths || null : noClipPaths || null
    const _link = useFieldsFromSettings ? siteSettings?.cta?.link || null : link || null
    const _contentAlignment = useFieldsFromSettings
        ? siteSettings?.cta?.contentAlignment || null
        : contentAlignment || null
    const _mainBackgroundColour = useFieldsFromSettings
        ? siteSettings?.cta?.mainBackgroundColour || null
        : mainBackgroundColour || null
    const _lightButtonColour = useFieldsFromSettings
        ? siteSettings?.cta?.lightButtonColour || null
        : lightButtonColour || null

    const __link =
        _link?.linkType === 'internal' || _link?.linkType === 'external' ? getSanityLink(_link) || null : null

    return (
        <section
            className={cn(
                s.Cta,
                _reverse && s.Reverse,
                _noClipPaths && s.NoClipPaths,
                hideMainTopBorder && s.HideMainTopBorder,
            )}
        >
            <div className={cn(s.Cont, 'container', _mainBackgroundColour === 'dark' && s.Dark)}>
                <div
                    className={cn(
                        s.Main,
                        _contentAlignment === 'topLeft' && s.TopLeft,
                        _contentAlignment === 'bottomLeft' && s.BottomLeft,
                    )}
                >
                    <div className={s.Content}>
                        {_title && <h1 dangerouslySetInnerHTML={{ __html: _title }} />}
                        {_copy && (
                            <div className={s.Copy}>
                                <Copy copy={_copy} />
                            </div>
                        )}
                        {__link && (
                            <Button
                                url={__link?.url || ''}
                                title={__link?.title || ''}
                                inverted={_mainBackgroundColour === 'dark'}
                                transparent
                                brightBlue={_lightButtonColour === 'bright-blue' && _mainBackgroundColour === 'light'}
                                deepNavy={_lightButtonColour === 'deep-navy' && _mainBackgroundColour === 'light'}
                            />
                        )}
                        {_showSocialLinks && <SocialLinks siteSettings={siteSettings} />}
                    </div>
                </div>
                {_image && (
                    <div className={s.Image}>
                        <ImageBox image={_image} alt={title || ''} width={800} height={800} />
                    </div>
                )}
            </div>
        </section>
    )
}

export default Cta
